module.exports = __webpack_public_path__ + "img/join-bg (4).839b423a.jpg";